export const API_URL = import.meta.env.VITE_API_URL
export const WOODONGS_URL = import.meta.env.VITE_WOODONGS_URL

export const SELECT_YN = ['Y', 'N']

export const GRID_LOADING = '조회 중입니다. 잠시만 기다려 주세요.'
export const GRID_INIT = '원하시는 조건 설정 후 조회 버튼을 눌러주세요.'
export const GRID_NO_SHOW_ROW = '조회된 데이터가 없습니다.'

export const GRID_NO_RESULT = '조회 결과가 없습니다.'
export const GRID_EXAM_PATH = 'gssm-package-fe/apps/app-pc-demo/src/components/example/aggrid/'
export const GRID_COMPONENTS_PATH = 'gssm-package-fe/apps/app-pc-demo/src/components/aggrid/'

// event key name
export const KEY_A = 'A'
export const KEY_C = 'C'
export const KEY_V = 'V'
export const KEY_D = 'D'
export const KEY_PAGE_UP = 'PageUp'
export const KEY_PAGE_DOWN = 'PageDown'
export const KEY_TAB = 'Tab'
export const KEY_LEFT = 'ArrowLeft'
export const KEY_UP = 'ArrowUp'
export const KEY_RIGHT = 'ArrowRight'
export const KEY_DOWN = 'ArrowDown'
export const KEY_F2 = 'F2'
export const KEY_BACKSPACE = 'Backspace'
export const KEY_ESCAPE = 'Escape'
export const KEY_SPACE = ' '
export const KEY_DELETE = 'Delete'
export const KEY_PAGE_HOME = 'Home'
export const KEY_PAGE_END = 'End'
export const KEY_ENTER = 'Enter'
